/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {JobPageOf, JobPageOfFromJSON, JobPageOfToJSON,} from './JobPageOf';

/**
 *
 * @export
 * @interface JobPageOfApiResult
 */
export interface JobPageOfApiResult {
    /**
     *
     * @type {boolean}
     * @memberof JobPageOfApiResult
     */
    success?: boolean;
    /**
     *
     * @type {JobPageOf}
     * @memberof JobPageOfApiResult
     */
    content?: JobPageOf;
    /**
     *
     * @type {string}
     * @memberof JobPageOfApiResult
     */
    message?: string | null;
}

export function JobPageOfApiResultFromJSON(json: any): JobPageOfApiResult {
    return JobPageOfApiResultFromJSONTyped(json, false);
}

export function JobPageOfApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobPageOfApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : JobPageOfFromJSON(json['content']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function JobPageOfApiResultToJSON(value?: JobPageOfApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': JobPageOfToJSON(value.content),
        'message': value.message,
    };
}

